import { bl_cms_post_comments_ext_RowClass } from '../../dbschema/bl_cms_post_comments_ext.model';
import { bl_cms_post_comments_hdr_RowClass } from '../../dbschema/bl_cms_post_comments_hdr.model';
import { BaseContainerModel } from '../base-container.model';

export class PostCommentContainerModel extends BaseContainerModel {
  bl_cms_post_comments_hdr: bl_cms_post_comments_hdr_RowClass = new bl_cms_post_comments_hdr_RowClass();
  bl_cms_post_comments_exts: bl_cms_post_comments_ext_RowClass[] = [];
}
